import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close() {
    // Remove the modal by clearing the turbo frame
    const frame = document.getElementById("imei_modal")
    if (frame) {
      frame.innerHTML = ""
    }
  }
}